import { Github, Linkedin, Mail  } from 'lucide-react';
import '../css/wallpaper.css'
import '../css/Fonts/GoogleFonts.css'

import { useEffect, useRef } from "react";
import ScrollReveal from "scrollreveal";



interface IcardWelcome {
    text_welcome:string,
    text_name: string,
    text_work:string,
    text_describe: string
}

export const CardWelcome = ({text_welcome,text_name,text_work, text_describe}:IcardWelcome) => {

    // 🔹 Ref da div da esquerda
  const leftRef = useRef<HTMLDivElement | null>(null);

  // 🔹 Ref da div da direita
  const rightRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const sr = ScrollReveal();

    // 🔥 Animação da esquerda
    if (leftRef.current) {
      sr.reveal(leftRef.current, {
        duration: 1500,
        distance: "80px",
        origin: "left",
        easing: "ease-in-out",
        reset: false, // anima toda vez que sair e entrar
      });
    }

    // 🔥 Animação da direita
    if (rightRef.current) {
      sr.reveal(rightRef.current, {
        duration: 1500,
        distance: "80px",
        origin: "right",
        easing: "ease-in-out",
        reset: false ,
      });
    }

    return () => sr.destroy();
  }, []);

    return(
       <> 
        <article className="z-10 flex justify-around mt-20">
           <div
           ref={leftRef} 
           className="text-gray-300 md:w-[50vw] flex flex-col gap-y-4 text-start p-5 fontText">
              <span>
                {text_welcome}
              </span>

              <span className="text-6xl font-bold text-gray-400 fontTitle md:hidden" >
                {text_name}
              </span>

              <span className="text-3xl font-bold text-gray-400">
                {text_work}
              </span>

              <span>
                {text_describe}
              </span>

              <div className=" flex justify-around md:w-[8vw] w-[3vw] gap-x-6 md:gap-x-3">
                 <button className="hover:border-red-600  hover:text-red-600 border border-gray-300 p-2 md:w-[3vw] rounded-md">
                    <a href="https://github.com/JeanWallace01" target='_blank' rel="noreferrer">
                      <Github/>
                    </a>
                 </button>

                 <button className="hover:border-red-600  hover:text-red-600 border border-gray-300 p-2 md:w-[3vw] rounded-md">
                    <a href="https://www.linkedin.com/in/jean-wallace-7b7293230/" target='_blank' rel="noreferrer">
                        <Linkedin />
                    </a>
                 </button>

                 <button className="border border-red-600 p-2 w-[3vw] rounded-md hidden">
                    <Mail />
                 </button>
              </div>

              <div className="justify-center items-center w-full mt-52 pl-[78%] md:block  hidden">
                <a href="#pageWithMe" target='_self'>
  <svg 
    className="size-7 animate-bounce w-[2vw] text-gray-200 font-bold bg-black p-2 rounded-2xl"
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 14l-7 7-7-7"/>
  </svg>
      </a>
</div>
              
           </div>

          
         
           <div
           ref={rightRef} 
           className="z-10 bg-black wallpaper md:block hidden md:w-[26vw] w-[28%] h-[24vh] md:h-[60vh] rounded-full content-center"> 
               
           </div>


          


        </article>
        </>
    )
}